module.exports = __webpack_public_path__ + "img/55.6.CODm.e56e8352.png";